const GAIN_TOAST_KEY = 'cart.sl_cashback.gain_toast';
const LOST_TOAST_KEY = 'cart.sl_cashback.lost_toast';

// Builds a payment-change toast trigger for the cashback hint, shared by the
// cart-form (single-cart) and cart-summary (multi-cart) directives. Each caller
// keeps its own instance so the sequence guard is scoped to that binding.
//
// Deps:
//   pnotifyService - { notify(message, options) }
//   translate      - (key) => localized string
//
// The returned function reads eligibility state from a payment-select change
// event, advances the sequence, and returns a deferred callback to run after the
// payment update resolves (so an out-of-order response cannot show a stale toast).
export const createSlCashbackPaymentToast = ({ pnotifyService, translate }) => {
  let latestSeq = 0;

  return (event) => {
    const select = event.currentTarget;
    const selectedOption = select.options[select.selectedIndex];
    const isContextActive =
      select.getAttribute('data-cashback-context-active') === 'true';
    const wasEligible =
      select.getAttribute('data-selected-cashback-eligible') === 'true';
    const isEligible =
      !!selectedOption &&
      selectedOption.getAttribute('data-cashback-eligible') === 'true';

    latestSeq += 1;
    const seq = latestSeq;

    return () => {
      if (!isContextActive) return;
      if (seq !== latestSeq) return;
      if (wasEligible === isEligible) return;

      if (isEligible) {
        pnotifyService.notify(translate(GAIN_TOAST_KEY), {});
      } else {
        pnotifyService.notify(translate(LOST_TOAST_KEY), {
          customClass: 'error',
          icon: 'fa fa-exclamation-triangle',
        });
      }
    };
  };
};
